import { Size } from '../../types';

export interface BaseProps {
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  errorText?: string;
  id?: string;
  label?: string;
  name?: string;
  'data-title'?: string;
  'data-accesskey'?: string;
}

export interface CheckboxProps extends BaseProps {
  defaultChecked?: boolean;
  onChange?: (event?: any) => void;
  checked?: boolean;
  size?: Size;
}

export type InputTypes = 'email' | 'number' | 'password' | 'phone' | 'text';

export interface TextInputProps extends BaseProps {
  autoComplete?: string;
  field?: any;
  input?: any;
  meta?: any;
  tabIndex?: any;
  onFocus?: (event?: any) => void;
  onBlur?: (event?: any) => void;
  onChange?: (event?: any) => void;
  type?: InputTypes;
  placeholder?: string;
  isrequired?: boolean;
  onComponentUnmount?: (value: string) => void;
  value?: string;
  maxlength?: number;
}

export interface SelectProps extends BaseProps {
  onChange?: (event?: any) => void;
  value?: any;
  full?: boolean;
  children: string | any[];
}

export interface PillsSelectProps extends BaseProps {
  onChange: (values: string[]) => void;
  onComponentUnmount?: (values: string[]) => void;
  options: QuestionOptions[];
  multiple?: boolean;
  color?: string;
  selected?: string[] | string;
}

export interface QuestionOptions {
  name: string;
  value: string;
  description?: string;
  accesskey?: string;
}
